<section>
  <ng-container *ngIf="minimalFormId">
    <gen-dynamic-form
            [popupMode]="true"
            [formName]="minimalFormId"
            [editMode]="true"
            [formData]=""
            [formVertical]="true"
            [disabled]="true"
            [requiredMessage]="''"
            [mapAllProperties]="true"
    ></gen-dynamic-form>
    <hr>
  </ng-container>
  <ng-container *ngIf="externalLinks">
    <section *ngFor="let linkItem of externalLinks">
      <a [href]="linkItem?.externalLink"
         target="_blank"
         class="Auto_link-">
        {{linkItem?.name}}
      </a>
      <hr>
    </section>
  </ng-container>
  <ng-container *ngIf="!actions">
    <section class="action-buttons-wrapper">
      <ng-container *ngIf="(hasAppNameAndCtInfo$ | async) && (permitOptellumContextLaunch$ | async)">
        <gen-button class="optellum-button-padding"
                [text]="optellumButtonLabel$ | async"
                (click)="launchOptellum()"></gen-button>
      </ng-container>

    <ispm-pacs-launcher class="button-pacs" *ngIf="pacsIntegrationAvailable"
      [currentEvent]="data">
    </ispm-pacs-launcher>

      <gen-button
              [iconClass]="'icon__DocumentText'"
              [text]="'Open event'"
              (click)="navigateToReport()"></gen-button>
    </section>
  </ng-container>
  <ng-container *ngIf="actions">
    <div class="new-action-buttons-wrapper" *ngFor="let action of actions">
      <gen-button
              *ngIf="(imageFileReferences && imageFileReferences.length>0 && action.action==='open_images')
                    || (videoFileReferences && videoFileReferences.length>0 && action.action==='open_videos')
                    || (dicomImageReferences && dicomImageReferences.length>0 && action.action==='open_images')
                    || (dicomVideoReferences && dicomVideoReferences.length>0 && action.action==='open_videos')
                    || action.action==='open_event'
                    || action.action==='open_context'
                    || ((hasAppNameAndCtInfo$ | async) && (permitOptellumContextLaunch$ | async) && (optellumURL$ | async))"
              [iconClass]="action?.icon"
              [text]="action?.label | translate"
              [type]="action?.primary? 'primary' : 'secondary'"
              (click)="onActionClick(action)"></gen-button>
    </div>
  </ng-container>
</section>

